var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',_vm._b({ref:"input",staticClass:"input-sigarus-textarea",attrs:{"type":"textarea","rows":"4"},on:{"focus":function($event){return _vm.$emit('focus')},"blur":function($event){return _vm.$emit('blur')}},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'el-input',{..._vm.$attrs, ..._vm.$props},false))
}
var staticRenderFns = []

export { render, staticRenderFns }